(function(){
  'use strict';
  const sizes=[[1260,99900],[1750,129900],[3500,179900],[7000,349900]];
  function customPrice(w,h){
    if(!Number.isInteger(w)||!Number.isInteger(h)||w<10||h<10||w>200||h>200)return null;
    const area=Math.max(w*h,7000*Math.pow((w+h)/170,2));
    if(area<=sizes[0][0])return sizes[0][1];
    for(let i=1;i<sizes.length;i++)if(area<=sizes[i][0]){
      const [a,p]=sizes[i-1], [b,q]=sizes[i];
      return Math.ceil((p+(area-a)/(b-a)*(q-p))/100)*100;
    }
    return Math.ceil((area/7000*349900)/100)*100;
  }
  function setPrice(base,n){return Math.round(base*n*({1:1,2:.9,3:.85}[n]));}
  if(typeof module!=='undefined')module.exports={customPrice,setPrice};
  if(typeof document==='undefined')return;
  document.querySelectorAll('[data-ani]').forEach(root=>{
    if(root.dataset.ready)return;root.dataset.ready='1';
    const product=JSON.parse(root.querySelector('[data-ani-product]').textContent);
    const cfg=JSON.parse(root.querySelector('[data-ani-config]').textContent);
    const $=s=>root.querySelector(s), all=s=>root.querySelectorAll(s);
    const money=v=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',minimumFractionDigits:v%100?2:0,maximumFractionDigits:2}).format(v/100);
    let mode='standard';
    function showImage(url,alt){$('.ani-hero').src=url;$('.ani-hero').alt=alt||product.title;$('.ani-hero-link').href=url;all('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.image===url)));}
    all('[data-image]').forEach(b=>b.addEventListener('click',()=>showImage(b.dataset.image,b.dataset.alt)));
    function updatePhotos(n){
      let needed=0,selected=0,reused=0;
      all('[data-photo-board]').forEach(board=>{
        const active=Number(board.dataset.photoBoard)<=n;
        const reuse=board.querySelector('[data-photo-reuse]');
        const same=Boolean(reuse?.checked);
        board.hidden=!active;
        if(reuse)reuse.disabled=!active;
        board.querySelector('[data-photo-grid]').hidden=same;
        board.querySelector('[data-reuse-note]').hidden=!same;
        const choice=board.querySelector('[data-photo-choice]');
        choice.disabled=!active;
        choice.value=same?'İlk panonun 5 fotoğrafı tekrar basılacak':'5 ayrı fotoğraf';
        if(active&&same)reused+=5;
        board.querySelectorAll('[data-photo]').forEach(input=>{
          input.disabled=!active||same;
          input.required=active&&!same;
          if(!input.disabled){needed++;if(input.files.length)selected++;}
        });
      });
      $('[data-photo-heading]').textContent=`${n*5} fotoğraf baskın için fotoğraflarını seç`;
      $('[data-photo-count]').textContent=`${selected} / ${needed} fotoğraf seçildi`+(reused?` · ${reused} baskı için ilk panonun fotoğrafları kullanılacak`:'');
    }
    function update(){
      const pack=$('.ani-packs input:checked').value,n={'Tekli':1,'İkili Set':2,'Üçlü Set':3}[pack],color=$('[data-color]').value,size=$('[data-size]').value;
      updatePhotos(n);
      const v=product.variants.find(v=>v.option1===size&&v.option2===color&&v.option3===pack);
      const single=product.variants.find(v=>v.option1===size&&v.option2===color&&v.option3==='Tekli');
      const w=Number($('[data-width]').value),h=Number($('[data-height]').value);
      const base=mode==='custom'?customPrice(w,h):single?.price;
      $('[data-standard]').hidden=mode!=='standard';$('[data-custom]').hidden=mode!=='custom';$('[data-cart-form]').hidden=mode!=='standard';$('[data-whatsapp]').hidden=mode!=='custom';
      $('[data-total-label]').textContent=mode==='custom'?'Hesaplanan set fiyatı':'Toplam';
      if(base==null){$('[data-total]').textContent='—';$('[data-saving]').textContent='';all('[data-pack-price]').forEach(e=>e.textContent='—');$('[data-error]').textContent='En ve boy için 10–200 cm arasında tam sayı gir.';$('[data-whatsapp]').hidden=true;return;}
      $('[data-error]').textContent='';
      const total=mode==='custom'?setPrice(base,n):v?.price;
      all('[data-pack-price]').forEach(e=>{const count=Number(e.dataset.packPrice);e.textContent=money(Math.round(setPrice(base,count)/count));});
      all('[data-original-price]').forEach(e=>e.textContent=money(base));
      $('[data-total]').textContent=money(total);
      $('[data-saving]').textContent=n>1?`Tekli alım toplamı ${money(base*n)} · ${money(base*n-total)} avantaj · Pano başına ${money(Math.round(total/n))}`:'1 çerçeveli pano + 5 fotoğraf baskısı + 5 mıknatıs';
      if(mode==='standard'){
        $('[data-variant]').value=v?.id||'';$('.ani-buy[type=submit]').disabled=!v?.available;$('[data-included]').value=`${n} pano + ${n*5} fotoğraf baskısı (9 × 13 cm) + ${n*5} mıknatıs`;
        if(!v?.available)$('[data-error]').textContent='Bu seçenek şu anda satışa açık değil.';
        const url=new URL(location.href);if(v)url.searchParams.set('variant',v.id);history.replaceState({},'',url);
      }else{
        const message=`Merhaba, Anı Panosu özel ölçü siparişi vermek istiyorum. Ölçü: ${w} × ${h} cm. Çerçeve: ${color}. Paket: ${n} pano + ${n*5} fotoğraf baskısı (9 × 13 cm) + ${n*5} mıknatıs. Hesaplanan toplam: ${money(total)}. Her pano için 5 fotoğrafı buradan ileteceğim; istersem aynı fotoğrafları tekrar kullanacağım. Kesim ve gönderim ayrıntılarını görüşebilir miyiz?`;
        $('[data-whatsapp]').href='https://wa.me/'+cfg.phone.replace(/\D/g,'')+'?text='+encodeURIComponent(message);
      }
    }
    all('[data-mode]').forEach(b=>b.addEventListener('click',()=>{mode=b.dataset.mode;all('[data-mode]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));update();}));
    all('select,input').forEach(e=>e.addEventListener('input',update));
    $('[data-color]').addEventListener('change',()=>{const v=product.variants.find(v=>v.option2===$('[data-color]').value&&v.featured_image);if(v)showImage(v.featured_image.src,`${$('[data-color]').value} çerçeveli Anı Panosu`);});
    const wanted=product.variants.find(v=>String(v.id)===new URL(location.href).searchParams.get('variant'));
    if(wanted){$('[data-size]').value=wanted.option1;$('[data-color]').value=wanted.option2;all('.ani-packs input').forEach(e=>e.checked=e.value===wanted.option3);}
    all('[data-photo]').forEach(input=>input.addEventListener('change',()=>{
      const box=input.closest('.ani-photo'), preview=box.querySelector('[data-photo-preview]'), error=box.querySelector('[data-photo-error]');
      if(preview.dataset.url)URL.revokeObjectURL(preview.dataset.url);
      preview.hidden=true;preview.removeAttribute('src');input.setCustomValidity('');error.textContent='';
      const file=input.files[0];
      if(file){
        let message='';
        if(!['image/jpeg','image/png'].includes(file.type))message='Lütfen JPG veya PNG fotoğraf seç.';
        else if(file.size>10*1024*1024)message='Fotoğraf 10 MB sınırını aşıyor. Daha küçük bir dosya seç.';
        if(message){input.value='';error.textContent=message;input.setCustomValidity(message);}
        else{preview.dataset.url=URL.createObjectURL(file);preview.src=preview.dataset.url;preview.hidden=false;}
      }
      update();
    }));
    all('[data-photo-reuse]').forEach(input=>input.addEventListener('change',update));
    $('[data-cart-form]').addEventListener('submit',()=>{
      const button=$('.ani-buy[type=submit]');button.disabled=true;button.textContent='Fotoğraflar yükleniyor…';
    });
    window.addEventListener('pageshow',()=>{update();$('.ani-buy[type=submit]').textContent='Sepete ekle';});
    update();
  });
})();
